import Link from 'next/link';
import { FC, memo, ReactNode, useEffect, useState } from 'react';

import { ScNavigationItem, ScNavigationItemProps } from './styled';
import { ScFaqItemProps } from '@/components/QuestionAnswerItem/styled';

export interface SelectedItemPosition {
  left: number;
  width: number;
}

type NavigationItemProps = Omit<ScNavigationItemProps, 'width'> & {
  title: string | ReactNode;
  handleSelectItem: (idx: number, id: string | null) => void;
  setSelectedItemPosition: (args: SelectedItemPosition) => void;
  widthOfMenu: number;
  link?: string;
  idx: number;
  itemId: string | null;
};

export const NavigationItem: FC<NavigationItemProps & ScFaqItemProps> = memo(
  ({
    title,
    isSelected,
    handleSelectItem,
    setSelectedItemPosition,
    widthOfMenu,
    link,
    idx,
    itemId,
    ...props
  }) => {
    const [menuItem, setMenuItem] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
      if (isSelected && title && menuItem) {
        setSelectedItemPosition({
          left: menuItem.offsetLeft,
          width: menuItem.offsetWidth,
        });
      }
    }, [isSelected, setSelectedItemPosition, title, widthOfMenu, menuItem]);

    return (
      <ScNavigationItem
        ref={(node) => (node ? setMenuItem(node) : undefined)}
        isSelected={isSelected}
        onClick={() => handleSelectItem(idx, itemId)}
        {...props}
      >
        {link ? <Link href={link}>{title}</Link> : <span>{title}</span>}
      </ScNavigationItem>
    );
  }
);
